import { compose, InferableComponentEnhancer, withHandlers, lifecycle } from 'recompose';

type Handler<TProps> = (props: TProps) => Function;
type Handlers<TProps> = { [handlerName: string]: Handler<TProps> };

const withContentItemMessageHandlers = <TProps>(handlers: Handlers<TProps>) => {
  return compose(
    withHandlers({
      handleMessage: (props: TProps) => (messageEvent: MessageEvent) => {
        if (!messageEvent || !messageEvent.data || !messageEvent.data.type || !handlers[messageEvent.data.type]) return;
        handlers[messageEvent.data.type](props)(messageEvent.data.eventModel);
      },
    }),
    lifecycle<{ handleMessage }, {}>({
      componentDidMount() {
        window.addEventListener('message', this.props.handleMessage);
      },
      componentWillUnmount() {
        window.removeEventListener('message', this.props.handleMessage);
      },
    })
  ) as InferableComponentEnhancer<TProps>;
};

export default withContentItemMessageHandlers;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/content-viewer/hoc/withContentItemMessageHandlers.ts